import { post } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main";

const state = {
  items: [],
  total: {},
  isLoadingData: true,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  isShowResultDialog: false,
  resultMsg: "",
  isSuccess: false,
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items[0];
    state.total = items[1];
    state.isLoadingData = false;
  },
  SET_IS_BTN_LOADING(state, isBtnLoading) {
    state.isBtnLoading = isBtnLoading;
  },
  SET_IS_LOADING_DATA(state, isLoadingData) {
    state.isLoadingData = isLoadingData;
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_DELETE_SUCCESS(state, value) {
    state.isShowResultDialog = value.state;
    state.resultMsg = value.msg;
    state.isSuccess = value.isSuccess;
  },
};

const actions = {
  async getItems({ commit }, payload) {
    try {
      commit("SET_IS_LOADING_DATA", true);
      return post("notification/index", payload, {
        id: 33,
        action: "view",
      })
        .then((response) => {
          // Handle paginated response - check if it's a paginated response
          if (response.data && response.data.data) {
            // Paginated response
            commit("SET_ITEMS", [response.data.data, response.data]);
          } else if (Array.isArray(response.data)) {
            // Array response
            commit("SET_ITEMS", [response.data, {}]);
          } else {
            // Single object or other structure
            commit("SET_ITEMS", [response.data, response.data]);
          }
          commit("SET_IS_BTN_LOADING", false);
          commit("SET_IS_LOADING_DATA", false);
          return response.data;
        })
        .catch((error) => {
          commit("SET_IS_LOADING_DATA", false);
          if (error.response.status == 408) {
            window.location.href = "/404";
          }
          return error;
        });
    } catch (error) {
      console.log(error);
      commit("SET_IS_LOADING_DATA", false);
      return error;
    }
  },
  
  async sendNotification({ commit }, payload) {
    try {
      commit("SET_IS_BTN_LOADING", true);
      
      // If sending to all users (no user_ids and no user_id), send to topic 'all'
      const isSendingToAll = !payload.user_id && (!payload.user_ids || payload.user_ids === null || (Array.isArray(payload.user_ids) && payload.user_ids.length === 0));
      
      const endpoint = payload.user_id 
        ? `app-user/send-notification/${payload.user_id}`
        : "notification/send-notification";
      
      return post(
        endpoint,
        {
          title: payload.title,
          description: payload.description,
          no_action: payload.no_action || null,
          no_action_data: payload.no_action_data || null,
          user_ids: isSendingToAll ? null : payload.user_ids,
        },
        {
          id: 33,
          action: "add",
        }
      )
        .then((response) => {
          commit("SET_IS_BTN_LOADING", false);
          const t = i18n.global.t;
          toast("success", t("notification_sent_successfully"));
          return response.data;
        })
        .catch((error) => {
          commit("SET_IS_BTN_LOADING", false);
          const t = i18n.global.t;
          if (error.response?.status === 408) {
            toast("error", t("you_dont_have_permission_to_do_this_action"));
            return error;
          }
          toast("error", t("something_wrong"));
          console.log(error);
          return error;
        });
    } catch (error) {
      console.log(error);
      commit("SET_IS_BTN_LOADING", false);
      return error;
    }
  },
};

const getters = {
  filterItems(state) {
    function deepSearch(obj, searchValue) {
      for (const key in obj) {
        const value = obj[key];

        if (value !== null && typeof value === "object") {
          if (deepSearch(value, searchValue)) {
            return true;
          }
        } else {
          if (
            value != null &&
            value.toString().toLowerCase().includes(searchValue.toLowerCase())
          ) {
            return true;
          }
        }
      }
      return false;
    }

    if (!state.search) {
      return state.items;
    }

    return state.items.filter((item) => {
      return deepSearch(item, state.search.toLowerCase());
    });
  },
  getResultDialog: (state) => state.isShowResultDialog,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
